<div class="card">
    <div class="row">
        <div class="col-lg-6">
            <div ngfDrop
                 multiple="1"
                 selectable="1"
                 [(validDrag)]="validComboDrag"
                 [(files)]="fileHR"
                 accept=".pdf,.jpg,.jpeg,.gif,.tif,.tiff,.png,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pps,.pptx,.ppsx,.sldx"
                 [(dragFiles)]="dragFiles"
                 class="drop-box"
                 [class.invalid-drag]="validComboDrag===false"
                 [class.valid-drag]="validComboDrag"
                 (filesChange)="personalInfoUpload()"
                 [ngfFixOrientation]="false">
                {{uploadText}}
            </div>
        </div>
        <div class="col-lg-6">
            <div *ngFor="let file of attNewFile;let $index=index" style="margin-top: 20px">
                {{file.Filename}}
                <button class="btn btn-danger btn-icon-only ml-1 mr-3" (click)="attachDelete($index)" *ngIf="file.File != null && file.Progress == null">
                    <i class="modus-icons">trash</i>
                </button>
                <div style="padding-left:15px;margin-top:5px;">
                    <div class="progress" style="width:250px;" *ngIf="file.Progress > 0">
                        <div class="progress-bar" role="progressbar" [ngStyle]="{ 'width': file.Progress + '%' }">{{file.Progress}}%</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>